import React, { useState, useEffect } from "react";
import {
  Pagination,
  TextField,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextareaAutosize,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import SubCategoryDialog from "./SubCategoryDialog";
import { SUB_CATEGORY_URL } from "../../Constants/Constants";
import AxiosInstance from "../../services/AxiosInstance";
import Switch from "@mui/material/Switch";

//Table view
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import Tooltip from "@mui/material/Tooltip";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Container from "react-bootstrap/Container";
import { createTheme, ThemeProvider, useTheme } from "@mui/material";
import AppTableView from "../AppTableView";
import { SOLUTIONS_SUB_CATEGORY_COLUMNS } from "../ticket/grid/GridDataConstants";
import GridViewIcon from "@mui/icons-material/GridView";
import ListIcon from "@mui/icons-material/List";
import IconButton from "@mui/material/IconButton";
import { isEmpty } from "../../Constants/RolesConstants";

const iconButtonStyle = {
  transition: "transform 0.2s, background-color 0.2s",
  margin: "0 8px",
  padding: "4px",
  borderRadius: "50%",
};

const selectedStyle = {
  backgroundColor: "#1976d2",
  color: "#fff",
  transform: "scale(1.2)",
};

const SubCategory = ({ componentPermissions }) => {
  const globaltheme = useTheme();
  const theme = createTheme({
    ...globaltheme,
    components: {
      MuiSelect: {},
    },
  });
  const [subCategories, setSubCategories] = useState([]);
  const [filteredSubCategories, setFilteredSubCategories] = useState([]);
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [viewListMode, setViewListMode] = useState(true);

  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [gridPage, setGridPage] = useState(0);
  // Simulate fetching categories
  useEffect(() => {
    getSubCategories();
  }, []);

  const getSubCategories = () => {
    AxiosInstance.get(SUB_CATEGORY_URL).then((response) => {
      setSubCategories(response.data.data);
      setFilteredSubCategories(response.data.data);
    });
  };
  // Handle search term change
  const handleSearch = (event) => {
    const term = event.target.value.toLowerCase();
    setSearchTerm(term);
    setFilteredSubCategories(
      subCategories.filter((subCategory) =>
        subCategory.name.toLowerCase().includes(term)
      )
    );
  };

  // Handle pagination change
  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handleViewModeChange = (event) => {
    if (viewListMode === true) {
      setViewListMode(false);
    } else {
      setViewListMode(true);
      setGridPage(0);
      setPage(1);
    }
    //getCategories();
  };

  // Pagination variables
  const subCategoriesPerPage = 3;
  const totalPages = Math.ceil(
    filteredSubCategories.length / subCategoriesPerPage
  );
  const currentSubCategories = filteredSubCategories.slice(
    (page - 1) * subCategoriesPerPage,
    page * subCategoriesPerPage
  );

  // Grid view
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  const handleChangePage = (event, newPage) => {
    setGridPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setGridPage(0);
  };

  const visibleRows = React.useMemo(
    () =>
      [...subCategories].slice(
        gridPage * rowsPerPage,
        gridPage * rowsPerPage + rowsPerPage
      ),
    [subCategories, gridPage, rowsPerPage]
  );

  return (
    <>
    <ThemeProvider theme={theme}>
      <div>
        <Grid container spacing={2} columns={16}>
          <Grid size={14}>
            {isEmpty(componentPermissions) ||
              componentPermissions ?.canCreate ? (
                <SubCategoryDialog
                  subCategoryId={0}
                  selectedSubCategoryName={""}
                  callSubCategories={getSubCategories}
                  componentPermissions={componentPermissions}
                  actionType="Add"
                  isEdit={false}
                />
              ) : null}
          </Grid>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              border: "1px solid #ddd",
              borderRadius: "8px",
              padding: "8px",
              width: "fit-content",
              margin: "auto",
            }}
          >
            <Tooltip title="List View" arrow>
              <IconButton
                onClick={() => setViewListMode(true)}
                style={{
                  ...iconButtonStyle,
                  ...(viewListMode ? selectedStyle : {}),
                }}
              >
                <ListIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Grid View" arrow>
              <IconButton
                onClick={() => setViewListMode(false)}
                style={{
                  ...iconButtonStyle,
                  ...(!viewListMode ? selectedStyle : {}),
                }}
              >
                <GridViewIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
          {/* Toggle Button  */}
          {/* <Grid size={8} style={{ paddingTop: "20px" }}>
              Grid
              <Switch
                checked={viewListMode}
                onChange={handleViewModeChange}
                inputProps={{ "aria-label": "controlled" }}
              />
            </Grid> */}
        </Grid>
        {/* {viewListMode === true ? (
            <Container fluid sx={{ padingLeft: "2px" }}> */}
        {/* <AssetItemDialog assetItemData={categoryData} callAssetItems={categoryData}/> */}
        {/* Add New Article Button */}

        {/* <Box sx={{ width: "100%" }}>
                <Paper sx={{ width: "100%", mb: 2 }}>
                  <AppTableView
                    rows={subCategories}
                    cols={SOLUTIONS_SUB_CATEGORY_COLUMNS({ getSubCategories })}
                    hasRowSelectableFn={() => null}
                    handleRowSelection={() => false}
                    checkboxSelection={false}
                    initialPageSize={5}
                  />
                </Paper>
              </Box>
            </Container>
          ) : (
            <div> */}
        {/* Search Box */}
        {/* <TextField
                label="Search Sub Categories"
                variant="outlined"
                fullWidth
                value={searchTerm}
                onChange={handleSearch}
                style={{ marginBottom: 20, width: "85%" }}
              /> */}

        {/* Article List */}
        {/* <Grid container spacing={3}>
                {currentSubCategories.map((subCategory) => (
                  <Grid item xs={12} sm={6} md={4} key={subCategory.id}>
                    <div style={{ padding: 20, border: "1px solid #ddd" }}>
                      <h2>
                        {" "}
                        <SubCategoryDialog
                          subCategoryId={subCategory.id}
                          selectedSubCategoryName={subCategory.name}
                          callSubCategories={getSubCategories}
                        />
                      </h2>
                      <p>{subCategory.description}</p>
                    </div>
                  </Grid>
                ))}
              </Grid> */}

        {/* Pagination */}
        {/* <Pagination
                count={totalPages}
                page={page}
                onChange={handlePageChange}
                style={{
                  marginTop: 20,
                  display: "flex",
                  justifyContent: "center",
                }}
              /> */}

        {/* Dialog for Adding Article */}
        {/* </div>
          )} */}
      </div>
    </ThemeProvider>
    <div>
      <br />
      {viewListMode === true ? (
        <Container fluid sx={{ padingLeft: "2px" }}>
          {/* <AssetItemDialog assetItemData={categoryData} callAssetItems={categoryData}/> */}
          {/* Add New Article Button */}

          <Box sx={{ width: "100%" }}>
            <Paper sx={{ width: "100%", mb: 2 }}>
              <AppTableView
                rows={subCategories}
                cols={SOLUTIONS_SUB_CATEGORY_COLUMNS({
                  getSubCategories,
                  componentPermissions,
                  actionType:
                  isEmpty(componentPermissions) ||
                    componentPermissions ?.["canUpdate"]
                      ? "Edit"
                      : "",                  
                })}
                initialPageSize={15}
              />
            </Paper>
          </Box>
        </Container>
      ) : (
          <div>
            <ThemeProvider theme={theme}>
              {/* Search Box */}
              <TextField
                label="Search Sub Categories"
                variant="outlined"
                fullWidth
                value={searchTerm}
                onChange={handleSearch}
                style={{ marginBottom: 20, width: "99%" }}
              />
            </ThemeProvider>

            {/* Article List */}
            <Grid container spacing={3}>
              {currentSubCategories.map((subCategory) => (
                <Grid item xs={12} sm={6} md={4} key={subCategory.id}>
                  <div style={{ padding: 20, border: "1px solid #ddd" }}>
                    <h2>
                      {" "}
                      <SubCategoryDialog
                        subCategoryId={subCategory.id}
                        selectedSubCategoryName={subCategory.name}
                        callSubCategories={getSubCategories}
                        componentPermissions={componentPermissions}
                        actionType="Edit"
                        isEdit={true}
                      />
                    </h2>
                    <p>{subCategory.description}</p>
                  </div>
                </Grid>
              ))}
            </Grid>

            {/* Pagination */}
            <Pagination
              count={totalPages}
              page={page}
              onChange={handlePageChange}
              style={{
                marginTop: 20,
                display: "flex",
                justifyContent: "center",
              }}
            />

            {/* Dialog for Adding Article */}
          </div>
        )}
    </div>
    </>
  );
};

export default SubCategory;
